import request from './request'
import { APP_FEATURES } from '@/config/appFeatures'
import type { AppFeature } from '@/config/appFeatures'

export type { AppFeature }
export { APP_FEATURES }

// 获取用户基本信息
export interface GetUserInfoResDto {
  roles: {
    isSuper: number,
    permissions: []
  },
  userInfo: {
    avatar: string
    'client_user_id': number
    'is_super': number
    'last_login_time': number
    mobile: string
    'real_name': string
    'user_name': string
  }
}

export function getAppName () {
    const base = extractBaseUrl(window.location.href)
    console.log(base, 'base')
    switch (base) {
    case 'anxinhr.com':
        return '安心优选'
    case 'qihuxing.com.cn':
        return '企护星'
    case 'langongdun.com':
        return '蓝工盾'
    case 'yuanqihu.com':
        return '预安企护'
    case 'jishibao10.com':
        return '及时宝'
    default:
        return '未知项目'
    }
}

/** 判断当前应用是否开启某特色能力，配置见 @/config/appFeatures */
export function hasAppFeature (feature: AppFeature | string) {
    const apps = APP_FEATURES[feature as AppFeature] as readonly string[] | undefined
    return !!apps && apps.includes(getAppName())
}

function extractBaseUrl (url: string) {
    const matches = url.match(/^(?:https?:\/\/)?(?:www\.)?([^/]+)/i)
    return matches ? matches[1] : null
}

export function getUserInfo (): Promise<GetUserInfoResDto> {
    return request.get('/client.user/info')
}

// 获取菜单
export interface UserMenuDto {
  name: string
  path: string
  hidden: boolean
  redirect: string
  alwaysShow: boolean
  meta: {
    title: string
    icon: string
    noCache: boolean
  }
  children?: UserMenuDto
}

export function getMenu (): Promise<UserMenuDto[]> {
    return request.get('/getRouters')
}

// 获取可切换公司列表
export function getUserCompanyList (): Promise<{
  client_name: string,
  client_user_id: number,
  client_create_time: string,
}[]> {
    return request.get('/client.user/switchList')
}

// 切换公司获取TOKEN
export function getUserToken (data: { clientUserId: number }): Promise<{ token: string }> {
    return request.post('/client.user/doSwitch', data)
}

// 获取验证码
export function getSms (params: { mobile: string }): Promise<void> {
    return request.get('/passport/sendSmsCode', {
        params
    })
}

// 登录
export interface LoginDto {
  mobile?: string
  smsCode?: string
  username?: string
  password?: string
  loginMode: string
}

interface LoginResDto {
  clientUserId: number
  token: string
}

export function login (data: LoginDto): Promise<LoginResDto> {
    return request.post('/passport/login', data)
}

// 获取用户所在公司信息
export interface UserCompanyInfo {
  name: string,
  project: {
    'name': string,
    'logo': string,
    'logo_square': string,
    'mp_qrcode': string
  }
}

export function getUserCompany (): Promise<{ clientInfo: UserCompanyInfo }> {
    return request.post('/client/info')
}

// 公司名称自动完成
export function companyNameAuto (params: { search: string }): Promise<string[]> {
    return request.get('/company/autoComplete', {
        params
    })
}

// 文件上传
export function fileUpload (data: FormData, config = {}): Promise<{
  fileInfo: {
    'file_name': string
    'external_url': string
    'preview_url': string
    'file_id': string
  }
}> {
    return request.post('/upload/file', data, config)
}
